<template>
  <exo-help-dialog title="System noise temperature">
    <p>
      In commmunications, receiver antennas will always capture both the
      transmitted signal and some thermal noise, which is directly related to
      the system noise temperature. This temperature is a function of:
    </p>
    <ul>
      <li>
        <strong>Antenna temperature</strong> or
        <strong>Sky Temperature</strong>: the temperature of the environment
        "observed" within the antenna beamwidth. It depends on the frequency and
        on where the antenna is pointing at. It is usually between 2.7 K (deep
        space temperature) and 290 K (average Earth temperature), but can be
        greatly increased due to noise at smaller frequencies, specially at VHF
        and UHF frequencies.
      </li>
      <li>
        <strong>System components</strong>: the combination of the temperature
        of the spacecraft components and the noise generated by the lines and
        amplifiers in the receiver system.
      </li>
    </ul>
    <br />
    <p>
      In space<strong>studio</strong>, you can directly input the resultant
      system noise temperature <katex-element expression="T_s" />. It is gonna
      be used to compute the <katex-element expression="G/T" />.
    </p>
    <tooltipEquationGT />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
import tooltipEquationGT from './tooltipEquationGT.vue'
export default {
  name: 'tooltipSystemNoiseTemperature',
  components: {
    tooltipEquationEbN0,
    tooltipEquationGT
  }
}
</script>
